// eslint-disable-next-line import/prefer-default-export
export enum Direction {
    UP = 'UP',
    DOWN = 'DOWN',
    RIGHT = 'RIGHT',
}
